import React, { FC } from 'react';
import { Spacer, Card } from '@components/1-atoms';
import { AppTemplate } from '@components/4-templates';
import { PageHeader, Button, Dropdown, IconButton, Input } from '@components/2-molecules';

import { STATE } from '@lib/constants';

import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
import Sandwich from '@assets/icons/sandwich';

import {PlaidButton} from '@lib/plaid';

import { useAccountType } from '@lib/hooks/useAccountType';
import { useAccount } from '@lib/hooks/useAccount';
import * as utils from '@lib/utils';
import useRest from '@lib/hooks/base/useRest';

import { ForwardedPageProps } from '@lib/constants';


const AccountCreate: FC<ForwardedPageProps> = ({ navigation, data = {}, onDone, ...props }) => {


    const [accountTypes,] = useAccountType({ state: STATE.READY });

    const [account, setAccount] = useAccount({ operation: 'POST', data: data, state: STATE.CANCEL });
    
    const updateData = (data: any): void => setAccount((account: any) => ({ ...account, data: { ...account.data, ...data } }));

    const _createAccount = () => setAccount({ ...account, state: STATE.READY });

    const _onAccounts = (accounts: Array<Object>) => {
        console.log(accounts);
        navigation.navigate( 'ChartOfAccounts' );
    };

    const _onDone = (data:any) => navigation.navigate( 'ChartOfAccounts' )
    onDone = onDone || _onDone;
    utils.onStateChange(  account, STATE.DONE, onDone);

    return (
        <AppTemplate hooks={[account, accountTypes]}>
            
            <PageHeader 
                title={"CREATE / ADD BANK ACCOUNT"}
                left={<IconButton  icon={<Sandwich />} onPress={navigation?.toggleDrawer} />} />

            <Spacer h={1} />

            <PlaidButton outlined onDone={_onAccounts} />
            
            <Spacer h={1} />
            
            <Card>
                <Spacer h={1} />
                <Input label={"Name"}
                    onChange={(value: any) => { updateData({ name: value }) }}
                    defaultValue={account?.data?.name}
                />
                <Spacer h={1} />

                <Input label={"Description"}
                    multiline
                    onChange={(value: any) => { updateData({ description: value }) }}
                    defaultValue={account?.data?.description}
                />
                <Spacer h={1} />

                <Input label={"Code (4 characters max.)"}
                    onChange={(value: any) => { updateData({ code: value }) }}
                    defaultValue={account?.data?.code}
                />
                <Spacer h={1} />
            </Card>
            <Spacer h={2} />

            <Card>
                <Dropdown label={"Account type"}
                    /* placeholder={null} */
                    elective={false}
                    onChange={(value: any) => { updateData({ accountType: value, accountTypeId: value?.id }) }}
                    defaultValue={account?.data?.accountType}
                    data={accountTypes?.data}
                />
            </Card>
            <Spacer h={2} />

            <Button onPress={_createAccount}>CREATE</Button><Spacer h={1} />
            
            <Spacer h={2} />
        </AppTemplate>
    );
};


export default withForwardedNavigationParams<ForwardedPageProps>()(AccountCreate);